import { ActionButton, Icon } from '@fluentui/react';
import { baseUrlAdmin } from '../../../../../constants/url.constant';
import { Utils } from '../../../../common/views/Utils';
import { ProductUtils } from '../../../../products/views/ProductUtils';
import { OrderStatus } from '../../../models/OrderModel';
import { OrderItemProps } from './OrderItemView';
import OrderTrackingView from '../../shared/OrderTrackingView';
import { OrderUtils } from '../../shared/OrderUtils';
import ChatButton from '../../../../common/views/ChatButton';

export default function OrderItemCompactView({ order, onDetail, onPlaceOrder, onCompleted }: OrderItemProps) {
    const now = new Date();
    let url = order.product ? ProductUtils.getImageUrl(baseUrlAdmin, order.product.picture) : "";
    const total = OrderUtils.getTotal(order);

    const width3 = Utils.getColumnWidth(3);
    const width4 = Utils.getColumnWidth(4);
    const width5 = Utils.getColumnWidth(5);
    const width6 = Utils.getColumnWidth(6);
    const width7 = Utils.getColumnWidth(7);
    const width9 = Utils.getColumnWidth(9);

    const isMobile = window.innerWidth <= 500;

    const descriptionLines = isMobile ? "one-line" : "two-lines";

    const requestDeliveryText = () => {
        return ""
    }

    const productInfo = () => {
        const product = order.product;

        return <div className="font-smaller left">
            <div className="ms-Grid-row">
                <div className={width7 + " font-bold"}>{order.customer}</div>
                <div className={width5 + " right"}>
                    {requestDeliveryText()}
                </div>
            </div>

            {product && <div>
                {!Utils.isNullOrEmpty(product.name) && <div>
                    {product.name}
                </div>}

                <div className="gray">
                    {!Utils.isNullOrEmpty(product.description) && <>
                        <div className={"limit-lines " + descriptionLines}>
                            {product.description}
                        </div>
                    </>}

                    {product.weight > 0 && <div>
                        Weight: {Utils.formatNumber(product.weight)} lbs
                    </div>}

                    {!Utils.isNullOrEmpty(product.dimension) && <div>
                        {product.dimension}
                    </div>}
                </div>
            </div>}

            {!Utils.isNullOrEmpty(order.note) && <div className="firmed limit-lines one-line">
                {order.note}
            </div>}
        </div>
    }

    const onProductDetail = () => {
        const product = order.product;

        if (product && product.link) {
            window.open(product.link, "_blank");
        } else {
            alert("Product link not available.");
        }
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width4 + " left"}>
                <ChatButton />
            </div>

            <div className={width4 + " center"}>
                {order.status === OrderStatus.quote && <>
                    <ActionButton
                        iconProps={{ iconName: "ShoppingCart" }}
                        onClick={() => onPlaceOrder(order.id, onCompleted)}
                    >Place Order</ActionButton>
                </>}
            </div>

            <div className={width4 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "NumberedListTextMirrored" }}
                    onClick={() => onDetail(order.id)}
                >Detail</ActionButton>
            </div>
        </div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            <div className="ms-Grid-row ph-5 pb-5">
                <div className={width3 + " left cursor"} onClick={onProductDetail}>
                    {OrderUtils.image(url, order.qty, 80, total, true)}
                </div>
                <div className={width9}>
                    {productInfo()}
                    <div className="ms-Grid-row pt-5 font-smaller">
                        <div className={width6 + " left"}>
                            {Utils.getDaysAndHoursDiffText(now, order.orderDate)}
                        </div>
                        <div className={width6 + " right"}>{order.warehouse.name}</div>
                    </div>

                    {OrderUtils.isOrderStatus(order.status) && <div>
                        <OrderTrackingView trackings={order.trackings} />
                    </div>}
                </div>
            </div>
            {actionRow()}
        </div>
    </div>;
}